// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"ae165cf8","97":"047485ff","154":"3bb87c4f","258":"3bb87c4f","264":"111d2d8f","569":"ee75fb00"}[chunkId] + ".chunk.css";
};